const baseURL = "https://multicanalita.doinnovation.it/api/upocket";


export { baseURL };